import React from 'react';
import { DashboardCard } from './DashboardLayout';
import { Calendar, Heart, ShoppingCart, User } from 'lucide-react';
import { cn } from '../ui/utils';

interface QuickStatsProps {
  plansCreated?: number;
  recipesSaved?: number;
  shoppingLists?: number;
  profileCompletion?: number;
  onStatClick?: (stat: 'plans' | 'recipes' | 'shopping' | 'profile') => void;
  className?: string;
}

export function QuickStats({
  plansCreated = 0,
  recipesSaved = 0,
  shoppingLists = 0,
  profileCompletion = 0,
  onStatClick,
  className
}: QuickStatsProps) {
  const stats = [
    {
      key: 'plans' as const,
      label: 'Plans Created',
      value: plansCreated,
      icon: Calendar,
      color: 'text-coral',
      bgColor: 'bg-coral/10',
    },
    {
      key: 'recipes' as const,
      label: 'Recipes Saved',
      value: recipesSaved,
      icon: Heart,
      color: 'text-red-500',
      bgColor: 'bg-red-50',
    },
    {
      key: 'shopping' as const,
      label: 'Shopping Lists',
      value: shoppingLists,
      icon: ShoppingCart,
      color: 'text-sage',
      bgColor: 'bg-sage/10',
    },
    {
      key: 'profile' as const,
      label: 'Profile Complete',
      value: profileCompletion,
      icon: User,
      color: 'text-coral',
      bgColor: 'bg-coral/10',
      suffix: '%',
    },
  ];

  return (
    <DashboardCard
      className={cn('col-span-1 md:col-span-4 lg:col-span-4', className)}
      span={{ mobile: 1, tablet: 4, desktop: 4 }}
    >
      <h2 className="mb-4 text-xl font-semibold text-dusk">Quick Stats</h2>

      <div className="grid grid-cols-2 gap-4">
        {stats.map((stat) => {
          const Icon = stat.icon;

          return (
            <button
              key={stat.key}
              onClick={() => onStatClick?.(stat.key)}
              className="group flex flex-col items-start gap-2 rounded-lg p-4 text-left transition-colors hover:bg-neutral-50"
            >
              <div className={cn('rounded-lg p-2', stat.bgColor)}>
                <Icon className={cn('h-5 w-5', stat.color)} />
              </div>
              <div>
                <div className="text-2xl font-bold text-dusk">
                  {stat.value}{stat.suffix}
                </div>
                <div className="text-xs text-supporting">
                  {stat.label}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </DashboardCard>
  );
}
